import { Reveal } from "../components/Reveal";

export default function UeberPatrick() {
  return (
    <section className="bg-white py-20 sm:py-28 lg:py-32">
      <div className="mx-auto grid max-w-5xl items-start gap-12 px-5 sm:grid-cols-[auto_1fr] sm:gap-16 sm:px-8">
        <Reveal>
          <div className="relative" data-testid="portrait-patrick">
            <img
              src="/patrick-haefner.webp"
              alt="Patrick Häfner, Gründer von 2besales"
              className="aspect-[4/5] w-48 rounded-[2px] object-cover object-top sm:w-72"
              loading="lazy"
            />
            <div className="pointer-events-none absolute -left-3 -top-3 -z-0 h-full w-full rounded-[2px] border border-navy/15" />
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="flex items-center gap-4">
            <span className="h-px w-10 bg-navy/40" />
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-textgrau">Über Patrick</p>
          </div>
          <h2
            className="mt-6 text-2xl font-medium leading-snug tracking-[-0.01em] text-textdunkel sm:text-3xl lg:text-4xl"
            data-testid="patrick-ueberschrift"
          >
            Patrick Häfner, Gründer von 2besales
          </h2>
          <p className="mt-6 text-base leading-[1.85] text-textgrau" data-testid="patrick-text">
            Ich arbeite seit 2019 im LinkedIn-Vertrieb. Seitdem haben wir die LinkedIn-Profile von über 500
            Geschäftsführern betreut. Dabei habe ich vor allem eines gelernt: Am besten funktioniert es dort, wo die
            Zielgruppe klein ist und der Kundenwert hoch. Deshalb sage ich in der Analyse auch dann offen Nein, wenn
            ein Unternehmen nicht passt. Seit 2024 übernehmen wir mit 2besales die komplette
            Neukundengewinnung als Done-for-You-Leistung. Für ausgewählte Kunden aus Finanzbranche, Industrie und
            Beratung im DACH-Raum.
          </p>
          <p className="mt-8 border-t border-navy/10 pt-5 text-xs font-semibold uppercase tracking-[0.2em] text-textgrau" data-testid="patrick-firma">
            2besales GmbH · Grünwald bei München
          </p>
        </Reveal>
      </div>
    </section>
  );
}
